import {
  SYSTEM_TOKEN,
  SYSTEM_TOKEN_REDE,
  SYSTEM_TOKEN_PIVO,
  SYSTEM_TOKEN_LOJAS_AVENIDA,
} from 'gatsby-env-variables'
import storage from 'utils/storage'
import { isPivo } from './isPivo'

export const systemTokens = {
  recovery: SYSTEM_TOKEN,
  itaucard: SYSTEM_TOKEN, // Usado para o teste a/b com o fluxo laranja
  rede: SYSTEM_TOKEN_REDE,
  pivo: SYSTEM_TOKEN_PIVO,
  lojasAvenida: SYSTEM_TOKEN_LOJAS_AVENIDA,
}

export const getSystemToken = () => {
  const isLojasAvenida = storage.local.getItem('isLojasAvenida') === true

  const options = (isPivo() && 'pivo') || (isLojasAvenida && 'lojasAvenida')

  const theme = options || storage.session.getItem('theme') || 'recovery'

  return theme ? systemTokens[theme] : systemTokens.recovery
}
